import React, { useEffect } from "react";

import { Icon } from "./icons";

/**
 * Boîte de confirmation du design (ConfirmDialog.dc.html) : picto teinté,
 * titre, message, bouton secondaire facultatif et bouton principal.
 * `tone` : brand, danger ou warning. Sans `cancel`, un seul bouton.
 */
export default function ConfirmDialog({
  open,
  icon,
  tone = "brand",
  title,
  message,
  cancel,
  confirm,
  onCancel,
  onConfirm,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => event.key === "Escape" && onCancel();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="wosh-ord-dialog" onClick={onCancel}>
      <div
        className="wosh-ord-dialog__box"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="wosh-ord-dialog-title"
        onClick={(event) => event.stopPropagation()}
      >
        {icon && (
          <span className={`wosh-ord-dialog__icon wosh-ord-dialog__icon--${tone}`}>
            <Icon name={icon} />
          </span>
        )}
        <h2 className="wosh-ord-dialog__title" id="wosh-ord-dialog-title">
          {title}
        </h2>
        <p className="wosh-ord-dialog__message">{message}</p>
        <div className="wosh-ord-dialog__actions">
          {cancel && (
            <button type="button" className="wosh-ord-dialog__btn wosh-ord-dialog__btn--secondary" onClick={onCancel}>
              {cancel}
            </button>
          )}
          <button
            type="button"
            className="wosh-ord-dialog__btn wosh-ord-dialog__btn--primary"
            onClick={onConfirm}
            autoFocus
          >
            {confirm}
          </button>
        </div>
      </div>
    </div>
  );
}
